import React, { useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import user from "../../assets/img/display-pics.jpg";
import { FaFacebookSquare, FaInstagram, FaTwitter } from 'react-icons/fa';

const Agents = () => {

  useEffect(() => {
    document.title = "Island Luxury - Our Agents"
  }, [])

  const agents = [1,2,3,4,5,6,7,8]

  return (
    <div id="agents">
      <Header />
      <main>
        <section className="intro-area">
          <div className="intro-area_wrap container">
            <h1>Our Agents</h1>
          </div>
        </section>
        <section className="agent-cards container">
          {agents.map(i => 
            <div key={i} className="agent-card">
              <div className="agent-card_img">
                <img src={user} alt="User" />
              </div>
              <div className="agent-card_details">
                <h2>Bola Makinwa</h2>
                <div className="agent-card_social">
                  <NavLink to="#">
                    <FaFacebookSquare size={15} />
                  </NavLink>
                  <NavLink to="#">
                    <FaInstagram size={15} />
                  </NavLink>
                  <NavLink to="#">
                    <FaTwitter size={15} />
                  </NavLink>
                </div>
              </div>
            </div>
          )}
        </section>
        <Footer />
      </main>
    </div>
  )
}

export default Agents
